var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 61,
    viewBox: "0 0 57 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6423 46.5821L52.2851 44.4036V39.2142C52.2798 36.128 51.1837 33.1431 49.1903 30.787C47.197 28.4309 44.4349 26.8554 41.3923 26.3389V21.7856H37.0351V26.3389C33.9925 26.8554 31.2304 28.4309 29.2371 30.787C27.2438 33.1431 26.1476 36.128 26.1423 39.2142V44.4036L21.7852 46.5821V56.6428H34.8566V60.9999H43.5709V56.6428H56.6423V46.5821ZM52.2851 52.2856H26.1423V49.2748L30.4994 47.0963V39.2142C30.4994 36.903 31.4175 34.6865 33.0518 33.0523C34.686 31.418 36.9025 30.4999 39.2137 30.4999C41.5249 30.4999 43.7414 31.418 45.3756 33.0523C47.0099 34.6865 47.928 36.903 47.928 39.2142V47.0963L52.2851 49.2748V52.2856Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2857 8.71428C52.2857 7.55869 51.8266 6.45044 51.0095 5.63332C50.1924 4.81619 49.0841 4.35714 47.9285 4.35714H39.2143V0H34.8571V4.35714H17.4286V0H13.0714V4.35714H4.35714C3.20155 4.35714 2.0933 4.81619 1.27618 5.63332C0.459054 6.45044 0 7.55869 0 8.71428V52.2857C0 53.4413 0.459054 54.5495 1.27618 55.3666C2.0933 56.1838 3.20155 56.6428 4.35714 56.6428H13.0714V52.2857H4.35714V8.71428H13.0714V13.0714H17.4286V8.71428H34.8571V13.0714H39.2143V8.71428H47.9285V21.7857H52.2857V8.71428Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.6c152e248d7ce1b5868c9673aa947a0c.svg";
export { ForwardRef as ReactComponent };